import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from 'directives/directives.module';
import { EquipmentScannerPage } from './equipment-scanner-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
  declarations: [EquipmentScannerPage],
  imports: [PagesModule, ComponentsModule, DirectivesModule],
})
export class EquipmentScannerPageModule { }
